
@if (title() && durationMinutes()) {
  <main class="card__main">
    <h2 
      class="card__title ci-paragraph-p1-semibold"
      [class.card__title--one-line]="isDuration15Minutes()"
    >
      {{ title() | translate }}
    </h2>
    
    <span class="card__duration ci-caption-semibold">
      {{ durationMinutes() | duration }}
    </span>
  </main>
}